export type ConfirmationDialogDataType = {
  title: string;
  confirmLabel: string;
  confirmValue: string | boolean | number;
  declineLabel: string;
  declineValue: string | boolean | number;
  // do not add new buttons to the confirmation dialog - it should be confirm/deny only
};

export const defaultConfirmationDialogData: ConfirmationDialogDataType = {
  confirmLabel: 'Confirm',
  confirmValue: true,
  declineLabel: 'Cancel',
  declineValue: false,
  title: 'Do you want to perform the action?',
};
